import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useParams } from 'react-router';
import QueryRenderer from '../../../../../shared/relay/QueryRenderer';
import ContractorDetailsContent from './ContractorDetailsContent';

const ContractorDetailsTab = props => {
  const { id } = useParams();

  return (
    <QueryRenderer
      query={graphql`
        query ContractorDetailsTabQuery($id: ID!) {
          contractor(id: $id) {
            ...ContractorDetailsContent_contractor
            ...ContractorInfo_contractor
            ...AddressInfo_contractor
            ...Notes_contractor
          }
        }
      `}
      variables={{ id }}
      render={relayProps => (
        <ContractorDetailsContent
          contractor={relayProps.contractor}
          relayProps={relayProps}
          {...props}
        />
      )}
    />
  );
};

export default ContractorDetailsTab;
